export const GET_MEMBERS = 'GET_MEMBERS';
export const GET_MEMBERCOUNT = 'GET_MEMBER';
export const GET_MEMBERGROUPS = 'GET_MEMBERGROUPS';
export const GET_MEMBERSLIST = 'GET_MEMBERSLIST';
export const GET_CONFIG = 'GET_CONFIG';
export const GET_CONTACT_PERSON = `GET_CONTACT_PERSON`;
export const UPDATE_MEMBERGROUP = `UPDATE_MEMBERGROUP`
export const UPDATE_CONTACTPERSON = `UPDATE_CONTACTPERSON`
export const UPDATE_MEMBERS = `UPDATE_MEMBERS`
export const UPDATE_BANKDATA = `UPDATE_BANKDATA`
export const UPDATE_STATUS_MEMBERGROUP = `UPDATE_STATUS_MEMBERGROUP`
export const CREATE_MEMBERGROUP =  `CREATE_MEMBERGROUP`
export const CREATE_MEMBER =  `CREATE_MEMBER`

// events
export const GET_EVENTS =  `GET_EVENTS`
export const GET_EVENT_DETAILS =  `GET_EVENT_DETAILS`
export const UPDATE_EVENT = `UPDATE_EVENT`

// participants
export const GET_PARTICIPANTS =  `GET_PARTICIPANTS`
export const UPDATE_PARTICIPANT =  `UPDATE_PARTICIPANT`
export const UPDATE_STATUS_PARTICIPANT =  `UPDATE_STATUS_PARTICIPANT`

// persons
export const GET_PERSONS =  `GET_PERSONS`

// member type correction
export const START_MEMBER_TYPE_CORRECTION_RUN = `START_MEMBER_TYPE_CORRECTION_RUN`
export const GET_MEMBER_TYPE_CORRECTION_RUN = `GET_MEMBER_TYPE_CORRECTION_RUN`
export const GET_MEMBER_TYPE_CORRECTION_PREVIEW = `GET_MEMBER_TYPE_CORRECTION_PREVIEW`
export const APPLY_MEMBER_TYPE_CORRECTION_STEP = `APPLY_MEMBER_TYPE_CORRECTION_STEP`
export const SKIP_MEMBER_TYPE_CORRECTION_STEP = `SKIP_MEMBER_TYPE_CORRECTION_STEP`
export const GET_MEMBER_TYPE_CORRECTION_SUMMARY = `GET_MEMBER_TYPE_CORRECTION_SUMMARY`
export const CREATE_MEMBER_TYPE_CORRECTION_BILLING = `CREATE_MEMBER_TYPE_CORRECTION_BILLING`
export const RESET_MEMBER_TYPE_CORRECTION = `RESET_MEMBER_TYPE_CORRECTION`
